
export default function () {

  return {
    items: [],
    loading: false,
    total: 0,
    limit: 12,
    offset: 0,
    search: '',
    order: 'none', // "tickets" or "messages"
    noPlaceId: false,
    placeId: '',
    cityIds: [],
    item: null,
    itemLoading: false,
  };
}
